import { render, staticRenderFns } from "./FirstStepConfirm.vue?vue&type=template&id=1ac0b86a&scoped=true&"
import script from "./FirstStepConfirm.vue?vue&type=script&lang=js&"
export * from "./FirstStepConfirm.vue?vue&type=script&lang=js&"
import style0 from "./FirstStepConfirm.vue?vue&type=style&index=0&id=1ac0b86a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac0b86a",
  null
  
)

export default component.exports